import * as THREE from 'three'

export default function clearCanvasOverlay(name: string) {
  const mesh = (window as any).threeViewer?.product?.getObjectByName(name) as
    | THREE.Mesh<THREE.BufferGeometry, THREE.MeshStandardMaterial>
    | undefined

  if (!mesh) {
    console.warn(`Mesh not found, or material is not MeshStandardMaterial for: ${name}`)
    return
  }

  const ud = mesh.userData

  if (ud.overlayTexture) {
    ud.overlayTexture?.dispose?.()
    delete ud.overlayTexture
  }

  // Dispose back-face overlay texture and remove dynamically created canvas
  if (ud.overlayTextureBack) {
    ud.overlayTextureBack?.dispose?.()
    delete ud.overlayTextureBack
  }
  const backCanvas = document.querySelector(`#targetObjectCanvas-${name}-back`)
  if (backCanvas) backCanvas.remove()

  // Restore the original material if it was stored
  if (ud.originalMaterial) {
    mesh.material = ud.originalMaterial.clone()
    mesh.material.needsUpdate = true
  } else {
    // Fallback: remove old shader hooks and force standard compile path
    const mat = mesh.material as THREE.MeshStandardMaterial
    mat.onBeforeCompile = () => {}
    ;(mat as any).customProgramCacheKey = () => 'std' // avoid reusing old program
    mat.needsUpdate = true
    mesh.material = mat
  }
}
